<template>
  <div class="pwd_container">
    <div class="title">
      验证码登录
    </div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="captchaForm.username"
        placeholder="请输入手机号"
        autocomplete="new-password"
        class="field_item"
      />

      <van-field
        v-model="captchaForm.code"
        placeholder="请输入验证码"
        autocomplete="new-password"
        class="field_item "
      >
        <template #button>
          <span class="code" @click="getCode" v-if="state.smsSendBtn">
            获取验证码
          </span>
          <span v-else class="code2">
            {{ '(' + state.time + 's)后重新发送' }}
          </span>
        </template>
      </van-field>

      <div class="pwd_btn">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#F93244"
          :disabled="!captchaForm.username || !captchaForm.code"
        >
          立即登录
        </van-button>
      </div>
    </van-form>
    <div class="action_btn">
      <span class="red" @click="openLink('/register')">立即注册 </span> |
      <span @click="openLink('/rePwd')">忘记密码</span>
    </div>
  </div>
</template>

<script>
import { sipSms, sipLogin } from '@/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';

export default {
  data() {
    return {
      captchaForm: {
        username: '',
        code: ''
      },
      state: {
        time: 60,
        smsSendBtn: true
      }
    };
  },
  methods: {
    onSubmit() {
      const { captchaForm } = this;
      if (!captchaForm.username.trim() || !captchaForm.code.trim()) {
        return this.$toast.fail('请输入完整内容');
      }
      sipLogin(captchaForm).then((res) => {
        if (res.success) {
          const data = res.data;
          Vue.ls.set(ACCESS_TOKEN, data.token, 7 * 24 * 60 * 60 * 1000);
          this.$toast.success('登录成功');

          // 延迟 0.5 秒显示欢迎信息
          setTimeout(() => {
            this.captchaForm = '';
            if (this.$route.query.redirect) {
              let redirect = decodeURIComponent(this.$route.query.redirect);
              this.$router.push({ path: redirect });
            } else {
              this.$router.push({ path: '/' });
            }
          }, 500);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    openLink(path) {
      if (path == '/register' && Vue.ls.get('inviterCode')) {
        this.$router.push({
          path,
          query: {
            c: Vue.ls.get('inviterCode')
          }
        });
      } else {
        this.$router.push(path);
      }
    },
    getCode() {
      console.log('发送验证码');
      const { state, captchaForm } = this;
      if (!captchaForm.username.trim()) {
        return this.$toast.fail('请输入手机号');
      }
      if (!/^1[3456789]\d{9}$/.test(captchaForm.username)) {
        return this.$toast.fail('请输入正确的手机号');
      }
      state.smsSendBtn = false;
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 60;
          state.smsSendBtn = true;
          window.clearInterval(interval);
        }
      }, 1000);
      sipSms(captchaForm.username, 2)
        .then((res) => {
          if (res.success) {
            this.$toast.success('验证码获取成功');
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          clearInterval(interval);
          state.time = 60;
          state.smsSendBtn = true;
          this.$toast.fail(err.message);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.pwd_container {
  padding: 19.733vw 0;
  .red {
    color: #f93244;
  }
  .title {
    padding-left: 4.267vw;
    font-size: 7.467vw;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8.533vw;
  }
  .field_item {
    height: 14.933vw;
    margin-bottom: 4.267vw;
    display: flex;
    align-items: center;
    font-size: 4.533vw;
    color: rgba(0, 0, 0, 0.25);
    .code {
      font-size: 4.533vw;
      color: #f93244;
      padding: 6px 10px;
    }
    .code2 {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }

  .pwd_btn {
    padding: 24.533vw 4.267vw 5.333vw;
  }
  .action_btn {
    text-align: center;
    color: rgba(0, 0, 0, 0.25);
    font-size: 3.733vw;
  }
}
/deep/ .van-field__control {
  font-size: 4.533vw;
}
</style>
